import { Button, Space } from 'antd'
import { LeftOutlined, RightOutlined } from '@ant-design/icons'

type PdfPagerProps = {
  page: number
  numPages: number
  onChange: (page: number) => void
}

export const PdfPager = ({ page, numPages, onChange }: PdfPagerProps) => (
  <Space>
    <Button
      size="small"
      icon={<LeftOutlined />}
      disabled={page <= 1}
      onClick={() => onChange(page - 1)}
    />
    <span>
      {page} / {numPages}
    </span>
    <Button
      size="small"
      icon={<RightOutlined />}
      disabled={page >= numPages}
      onClick={() => onChange(page + 1)}
    />
  </Space>
)
